// Swedish UI texts. Key = the English text in the code (see src/i18n/index.js).
// Missing keys fall back to English, so it is safe to add texts in any order.
const dict = {
  " (shared)": " (delad)",
  "\" — will be moved here": "\" — flyttas hit",
  "(*) fields are required.": "Fält med (*) är obligatoriska.",
  "+ Add Screen": "+ Lägg till skärm",
  "+ Add User": "+ Lägg till användare",
  "+ Create Playlist": "+ Skapa spellista",
  ". Only selected screens will be accessible.": ". Bara valda skärmar blir åtkomliga.",
  "1 column": "1 kolumn",
  "2 columns": "2 kolumner",
  "3 columns": "3 kolumner",
  "4 columns": "4 kolumner",
  "Account created successfully": "Kontot har skapats",
  "Action": "Åtgärd",
  "Actions": "Åtgärder",
  "Active": "Aktiv",
  "Add Analog Clock": "Lägg till analog klocka",
  "Add clock widget": "Lägg till klocka",
  "Add Content": "Lägg till innehåll",
  "Add content to get started": "Lägg till innehåll för att komma igång",
  "Add Date": "Lägg till datum",
  "Add Digital Clock": "Lägg till digital klocka",
  "Add floor": "Lägg till våning",
  "Add Item": "Lägg till objekt",
  "Add member": "Lägg till medlem",
  "Add Notiz Support": "Lägg till Notiz-support",
  "Add organization": "Lägg till organisation",
  "Add PDF": "Lägg till PDF",
  "Add QrCode": "Lägg till QR-kod",
  "Add Register to canvas": "Lägg till register på layouten",
  "Add row": "Lägg till rad",
  "Add Screen": "Lägg till skärm",
  "Add screen": "Lägg till skärm",
  "Add Temperature": "Lägg till temperatur",
  "Add Text": "Lägg till text",
  "Add text": "Lägg till text",
  "Add to Playlist": "Lägg till i spellista",
  "Add URL": "Lägg till URL",
  "Add URL link content": "Lägg till länk som innehåll",
  "Add User": "Lägg till användare",
  "Add Weather": "Lägg till väder",
  "Add weather widget": "Lägg till väder",
  "Add Widgets": "Lägg till widgetar",
  "Added to playlist": "Tillagd i spellistan",
  "Admin": "Admin",
  "Align": "Justera",
  "Alignment": "Justering",
  "All": "Alla",
  "All screens": "Alla skärmar",
  "Already have an account? Login": "Har du redan ett konto? Logga in",
  "Apk": "APK",
  "Apk File": "APK-fil",
  "Apk Management": "APK-hantering",
  "Apk saved successfully": "APK sparad",
  "Appearance": "Utseende",
  "Apply": "Verkställ",
  "Apply Size": "Använd storlek",
  "Apps": "Appar",
  "Are you sure to delete this file?": "Vill du ta bort filen?",
  "Are you sure to perform this action?": "Vill du utföra åtgärden?",
  "Are you sure to Update Time?": "Vill du uppdatera tiden?",
  "Asset": "Fil",
  "Assign": "Tilldela",
  "Assign Playlist to Screens": "Tilldela spellista till skärmar",
  "Assign screens": "Tilldela skärmar",
  "Assign screens for": "Tilldela skärmar för",
  "Assign to screens": "Tilldela skärmar",
  "Assign to Screens (shared)": "Tilldela skärmar (delad)",
  "Assigned to this playlist": "Tilldelade till spellistan",
  "Auto (by number of floors)": "Auto (efter antal våningar)",
  "Available screens": "Tillgängliga skärmar",
  "Back": "Tillbaka",
  "Back to Forgetpassword": "Tillbaka till glömt lösenord",
  "Background": "Bakgrund",
  "Background Color:": "Bakgrundsfärg:",
  "Bandwidth": "Bandbredd",
  "Bandwidth detail ·": "Bandbredd, detaljer ·",
  "Bandwidth overview": "Översikt bandbredd",
  "Barcode Type:": "Kodtyp:",
  "black": "svart",
  "Body": "Brödtext",
  "Body text": "Brödtext",
  "Bold": "Fet",
  "Border Color": "Kantfärg",
  "Both fill the layout. Background is behind everything and removes this image from the layer list.": "Båda fyller layouten. Bakgrund ligger bakom allt och tar bort bilden från lagerlistan.",
  "Bring Front": "Flytta fram",
  "Browse": "Bläddra",
  "Cancel": "Avbryt",
  "Canvas": "Arbetsyta",
  "Canvas Size": "Storlek på arbetsytan",
  "Choose a fixed count so the register matches your layout, or Auto to scale columns with floor count (legacy behavior).": "Välj ett fast antal så att registret passar layouten, eller Auto för att anpassa kolumnerna efter antal våningar (tidigare beteende).",
  "Choose a playlist from the list to view and manage its content": "Välj en spellista i listan för att se och hantera innehållet",
  "Choose style": "Välj stil",
  "City": "Stad",
  "Clear": "Rensa",
  "Clear Canvas": "Rensa arbetsytan",
  "Clear canvas": "Rensa arbetsytan",
  "Clear layout background": "Ta bort layoutbakgrund",
  "Clock": "Klocka",
  "Clock appearance": "Klockans utseende",
  "Close": "Stäng",
  "close": "stäng",
  "Close App": "Stäng appen",
  "Close panels": "Stäng paneler",
  "Code": "Kod",
  "code": "kod",
  "Code:": "Kod:",
  "Color": "Färg",
  "Columns": "Kolumner",
  "Coming soon": "Kommer snart",
  "Compact": "Kompakt",
  "Company Website": "Företagets webbplats",
  "Computed Size": "Beräknad storlek",
  "Confirm": "Bekräfta",
  "Confirm new password": "Bekräfta nytt lösenord",
  "Confirm password": "Bekräfta lösenord",
  "Confirmation": "Bekräftelse",
  "Contact support": "Kontakta support",
  "Content": "Innehåll",
  "Content:": "Innehåll:",
  "Copy": "Kopiera",
  "Corner radius": "Hörnradie",
  "Could not add QR code to the layout.": "Kunde inte lägga till QR-koden i layouten.",
  "Could not search stops.": "Kunde inte söka hållplatser.",
  "Could not set layout background.": "Kunde inte sätta layoutbakgrund.",
  "Could not update transition": "Kunde inte uppdatera övergången",
  "Cover full layout": "Täck hela layouten",
  "Create": "Skapa",
  "Create content": "Skapa innehåll",
  "Create Layout": "Skapa layout",
  "Create Playlist": "Skapa spellista",
  "Create playlist": "Skapa spellista",
  "Create your first layout to get started": "Skapa din första layout för att komma igång",
  "Created": "Skapad",
  "Creates a new organization account. They sign in and add their own users from their User page.": "Skapar ett nytt organisationskonto. De loggar in och lägger till egna användare på sin användarsida.",
  "Creates a Notiz staff support account. They can open organizations and help with content, screens, and playlists. They cannot upload APKs, delete accounts, or change system-only settings.": "Skapar ett supportkonto för Notiz-personal. De kan öppna organisationer och hjälpa till med innehåll, skärmar och spellistor. De kan inte ladda upp APK:er, ta bort konton eller ändra systeminställningar.",
  "Creates members under a selected organization. Choose role as Admin, User or Viewer.": "Skapar medlemmar i en vald organisation. Välj rollen Admin, Användare eller Läsare.",
  "Currently on \"": "Nu på \"",
  "custom": "anpassad",
  "Daily Usage": "Daglig användning",
  "Dashboard": "Översikt",
  "Date": "Datum",
  "Date Format:": "Datumformat:",
  "De-active": "Inaktiv",
  "Delete": "Ta bort",
  "Delete content": "Ta bort innehåll",
  "Delete floor": "Ta bort våning",
  "Delete organization": "Ta bort organisation",
  "Delete Organization": "Ta bort organisation",
  "Delete Playlist": "Ta bort spellista",
  "Delete user": "Ta bort användare",
  "Delete User": "Ta bort användare",
  "Departures": "Avgångar",
  "Detail:": "Detaljer:",
  "Device Details": "Enhetsinformation",
  "Device Name": "Enhetsnamn",
  "Dimensions": "Mått",
  "Directory register updated: a line now separates each floor. Save the layout to publish it.": "Registret har uppdaterats: ett streck skiljer nu varje våning. Spara layouten för att publicera.",
  "Do you want to save?": "Vill du spara?",
  "Document file": "Dokumentfil",
  "Don't have an account? Register": "Har du inget konto? Registrera dig",
  "Down": "Ned",
  "Drag and drop image/video files here": "Dra och släpp bilder eller videor här",
  "Drag content from the right panel to add items": "Dra innehåll från panelen till höger för att lägga till",
  "Drag to reorder": "Dra för att ändra ordning",
  "Duplicate": "Duplicera",
  "Duration updated": "Tiden har uppdaterats",
  "e.g. Stockholm": "t.ex. Stockholm",
  "e.g. Östra Mårtensgatan 19": "t.ex. Östra Mårtensgatan 19",
  "Eastern Time": "Eastern Time",
  "Edit": "Redigera",
  "Edit Duration": "Ändra visningstid",
  "Edit duration": "Ändra visningstid",
  "Edit Playlist": "Redigera spellista",
  "Edit Screen": "Redigera skärm",
  "Edit URL": "Redigera URL",
  "Edit user": "Redigera användare",
  "element": "element",
  "Elements": "Element",
  "Elements panel": "Elementpanel",
  "Email": "E-post",
  "Email *": "E-post *",
  "Email has sended with Link successfully, please check your inbox": "Ett mejl med en länk har skickats. Kolla din inkorg.",
  "Email is not valid. Please provide valid email.": "Ogiltig e-postadress. Ange en giltig e-postadress.",
  "Email is required": "E-post krävs",
  "Email is required.": "E-post krävs.",
  "Embed Preview": "Förhandsvisning",
  "Embed Widget": "Inbäddad widget",
  "End Date": "Slutdatum",
  "End Time": "Sluttid",
  "Enter Html": "Ange HTML",
  "Enter location": "Ange plats",
  "Enter Name": "Ange namn",
  "Enter playlist name": "Ange namn på spellistan",
  "Enter screen code": "Ange skärmkod",
  "Enter screen name": "Ange skärmnamn",
  "Enter Url": "Ange URL",
  "Error": "Fel",
  "Export": "Exportera",
  "Export PNG": "Exportera PNG",
  "Fade": "Tona",
  "Failed to add content": "Kunde inte lägga till innehåll",
  "Failed to load playlist": "Kunde inte ladda spellistan",
  "Failed to remove content": "Kunde inte ta bort innehåll",
  "Failed to update duration": "Kunde inte uppdatera tiden",
  "Fit XY": "Fyll ytan",
  "Floor name (required)": "Våningsnamn (obligatoriskt)",
  "Floor name is required.": "Våningsnamn krävs.",
  "Floor size": "Våningsstorlek",
  "Floors & Rows": "Våningar och rader",
  "Font": "Typsnitt",
  "Font Size:": "Textstorlek:",
  "Forget Password": "Glömt lösenord",
  "Forget Password?": "Glömt lösenordet?",
  "Formatting": "Formatering",
  "From": "Från",
  "Full layout": "Hela layouten",
  "Give your playlist a name to get started": "Ge spellistan ett namn för att komma igång",
  "Glass card": "Glaskort",
  "Go to login": "Till inloggningen",
  "Gradient": "Gradient",
  "Gradient night": "Gradient natt",
  "Heading": "Rubrik",
  "Height": "Höjd",
  "Height:": "Höjd:",
  "height:": "höjd:",
  "Help & support": "Hjälp och support",
  "home": "start",
  "Humidity": "Luftfuktighet",
  "icon": "ikon",
  "ID": "ID",
  "Image": "Bild",
  "Image covers full layout.": "Bilden täcker hela layouten.",
  "Image replaced (size and position kept)": "Bilden har bytts (storlek och position behålls)",
  "Image Scale": "Bildskala",
  "Image set as full-screen layout background.": "Bilden är nu bakgrund för hela layouten.",
  "India (IST)": "Indien (IST)",
  "Invalid duration": "Ogiltig tid",
  "Ip Address": "IP-adress",
  "Italic": "Kursiv",
  "Items": "Objekt",
  "items": "objekt",
  "Items per page": "Per sida",
  "items •": "objekt •",
  "items • Total:": "objekt • Totalt:",
  "JPG, PNG or GIF. Max 5MB.": "JPG, PNG eller GIF. Max 5 MB.",
  "Knowledge base": "Kunskapsbank",
  "lab API tabs example": "flikar",
  "Landscape": "Liggande",
  "Last Active": "Senast aktiv",
  "Last Update": "Senast uppdaterad",
  "Last Update:": "Senast uppdaterad:",
  "Lat:": "Lat:",
  "Latitude": "Latitud",
  "Latitude Longitude requireq.": "Latitud och longitud krävs.",
  "Lauch App": "Starta appen",
  "Layer": "Lager",
  "Layers": "Lager",
  "Layout": "Layout",
  "Layout background cleared.": "Layoutbakgrunden är borttagen.",
  "Layouts": "Layouter",
  "Left": "Vänster",
  "Liquid crystal digital": "Digital LCD",
  "Live departures from a stop": "Avgångar i realtid från en hållplats",
  "Loading screens...": "Laddar skärmar...",
  "Loading…": "Laddar…",
  "Location": "Plats",
  "Login": "Logga in",
  "Login & Register": "Logga in och registrera",
  "login failed!": "Inloggningen misslyckades!",
  "login success!": "Inloggad!",
  "Logout": "Logga ut",
  "Lon:": "Lon:",
  "Longform text analog": "Analog med text",
  "Longitude": "Longitud",
  "MAC": "MAC",
  "Mac": "MAC",
  "Mac Address": "MAC-adress",
  "MAC:": "MAC:",
  "Manage screens": "Hantera skärmar",
  "Manage Shared Playlist": "Hantera delad spellista",
  "Manufacturing": "Tillverkare",
  "Matching your filters": "som matchar filtret",
  "Media": "Media",
  "Media Library": "Mediabibliotek",
  "Media Requests": "Mediaanrop",
  "Menu": "Meny",
  "message successfully": "Meddelandet har skickats",
  "Minimal bar": "Minimal list",
  "Minutes": "Minuter",
  "Monitor how much media each screen pulls from the server. Click a row to see daily usage and top assets.": "Se hur mycket media varje skärm hämtar från servern. Klicka på en rad för daglig användning och mest hämtade filer.",
  "My account": "Mitt konto",
  "Name": "Namn",
  "Name *": "Namn *",
  "Name or label": "Namn eller etikett",
  "Name, MAC, or code": "Namn, MAC eller kod",
  "New": "Ny",
  "New Password": "Nytt lösenord",
  "New password (leave blank to keep current)": "Nytt lösenord (lämna tomt för att behålla nuvarande)",
  "New password (optional)": "Nytt lösenord (valfritt)",
  "New York (EST)": "New York (EST)",
  "Next": "Nästa",
  "Next page": "Nästa sida",
  "No": "Nej",
  "No access · Assign": "Ingen åtkomst · Tilldela",
  "No asset breakdown available.": "Ingen uppdelning per fil finns.",
  "No bandwidth data found": "Ingen bandbreddsdata hittades",
  "No bandwidth recorded in this range.": "Ingen bandbredd registrerad under perioden.",
  "No content found": "Inget innehåll hittades",
  "No content in this playlist": "Inget innehåll i spellistan",
  "no data": "ingen data",
  "No entries yet. Use + Add User above to invite someone.": "Inga användare än. Använd + Lägg till användare ovan för att bjuda in någon.",
  "No items in this playlist": "Inga objekt i spellistan",
  "No layouts match your search": "Inga layouter matchar sökningen",
  "No layouts to display": "Inga layouter att visa",
  "No layouts yet": "Inga layouter än",
  "No media found": "Ingen media hittades",
  "No members listed for this organization.": "Organisationen har inga medlemmar.",
  "No members yet. Use Add member in the toolbar to add Admin, User, or Viewer under this organization.": "Inga medlemmar än. Använd Lägg till medlem i verktygsfältet för att lägga till Admin, Användare eller Läsare.",
  "No offline screens.": "Inga skärmar offline.",
  "No online screens.": "Inga skärmar online.",
  "No organizations match your search.": "Inga organisationer matchar sökningen.",
  "No organizations yet, or none match your search. Use Add organization to create one.": "Inga organisationer än, eller inga som matchar sökningen. Använd Lägg till organisation för att skapa en.",
  "No Playlist": "Ingen spellista",
  "No playlists found": "Inga spellistor hittades",
  "No playlists found.": "Inga spellistor hittades.",
  "No screen found for this code. Open Web player first (pairing), then enter the code as digits only — e.g. 6610 not 6 6 1 0.": "Ingen skärm hittades för koden. Öppna webbspelaren först (parkoppling) och skriv sedan koden med bara siffror, t.ex. 6610 och inte 6 6 1 0.",
  "No screens found.": "Inga skärmar hittades.",
  "No stop selected": "Ingen hållplats vald",
  "No users found": "Inga användare hittades",
  "None": "Ingen",
  "NOTIZ Logo": "NOTIZ-logga",
  "Notiz Support": "Notiz-support",
  "Number size": "Sifferstorlek",
  "of": "av",
  "Offline": "Offline",
  "Offset X": "Förskjutning X",
  "Offset Y": "Förskjutning Y",
  "offsetX:": "förskjutning X:",
  "offsetY:": "förskjutning Y:",
  "One playlist, many screens — add content once and every selected screen will show \"": "En spellista, många skärmar: lägg till innehåll en gång så visar alla valda skärmar \"",
  "Online": "Online",
  "Online:": "Online:",
  "Only image and MP4 video files can be uploaded here.": "Här kan bara bilder och MP4-videor laddas upp.",
  "Only one register can be added on canvas.": "Det får bara finnas ett register per layout.",
  "Only super admin can view screen bandwidth.": "Bara superadmin kan se skärmarnas bandbredd.",
  "Only templates can be copied": "Bara layouter kan kopieras",
  "Open App": "Öppna appen",
  "Organization": "Organisation",
  "Organization *": "Organisation *",
  "Organization settings (coming soon)": "Organisationsinställningar (kommer snart)",
  "Organizations": "Organisationer",
  "Orientation": "Orientering",
  "OS": "OS",
  "Overflow": "Inga fler sidor",
  "Overview": "Översikt",
  "Pacific Time": "Pacific Time",
  "Package": "Paket",
  "Padding": "Marginal",
  "Page": "Sida",
  "Pair code is required.": "Parkopplingskod krävs.",
  "Password": "Lösenord",
  "Password *": "Lösenord *",
  "Password and Confirm Password do not match.": "Lösenorden matchar inte.",
  "Password Changed.": "Lösenordet har ändrats.",
  "Password have been changed!": "Lösenordet har ändrats!",
  "Password is required": "Lösenord krävs",
  "Password must be at least 6 characters.": "Lösenordet måste vara minst 6 tecken.",
  "pcs": "st",
  "PDF": "PDF",
  "Phone Number": "Telefonnummer",
  "Play": "Spela",
  "Playlist": "Spellista",
  "Playlist assigned to 1 screen": "Spellistan har tilldelats 1 skärm",
  "Playlist created": "Spellistan har skapats",
  "Playlist have scheduled": "Spellistan har schemalagts",
  "Playlist is empty": "Spellistan är tom",
  "Playlist Items": "Objekt i spellistan",
  "Playlist name is required": "Spellistan måste ha ett namn",
  "Playlist not found": "Spellistan hittades inte",
  "Playlist removed from all screens": "Spellistan har tagits bort från alla skärmar",
  "Playlist Scale": "Spellistans skala",
  "Playlists": "Spellistor",
  "Please enter fileds.": "Fyll i fälten.",
  "Please log in to access playlists": "Logga in för att se spellistor",
  "Please log in to view playlists": "Logga in för att se spellistor",
  "Please select an image file (JPG, PNG, etc.)": "Välj en bildfil (JPG, PNG m.fl.)",
  "Please select organization": "Välj organisation",
  "PM": "PM",
  "Portrait": "Stående",
  "Position & size": "Position och storlek",
  "Preview": "Förhandsvisning",
  "Preview image": "Förhandsbild",
  "Previous": "Föregående",
  "Previous page": "Föregående sida",
  "Profile": "Profil",
  "Properties panel": "Egenskapspanel",
  "PROPERTY NAME": "FASTIGHETSNAMN",
  "px": "px",
  "PX Height": "Höjd (px)",
  "PX Width": "Bredd (px)",
  "QR Code Value:": "QR-kodens innehåll:",
  "Quick actions": "Snabbval",
  "Refresh App": "Uppdatera appen",
  "Register": "Register",
  "Registration successful. Please login.": "Registreringen lyckades. Logga in.",
  "Reload App": "Ladda om appen",
  "Remember me": "Kom ihåg mig",
  "Remove": "Ta bort",
  "Remove from all screens": "Ta bort från alla skärmar",
  "Remove from Playlist": "Ta bort från spellistan",
  "Remove row": "Ta bort rad",
  "Removed from playlist": "Borttagen från spellistan",
  "Requests": "Anrop",
  "Resend": "Skicka igen",
  "Reset": "Återställ",
  "Reset App": "Återställ appen",
  "Reset Password": "Återställ lösenord",
  "result": "resultat",
  "results": "resultat",
  "Right": "Höger",
  "Role": "Roll",
  "Role *": "Roll *",
  "Role is required": "Roll krävs",
  "Root Level": "Root-nivå",
  "Rounded": "Rundad",
  "Row size": "Radstorlek",
  "Rows": "Rader",
  "Save": "Spara",
  "Save access": "Spara åtkomst",
  "Save changes": "Spara ändringar",
  "Saving...": "Sparar...",
  "Scale": "Skala",
  "Scale Mode": "Skalläge",
  "Scale X": "Skala X",
  "Scale Y": "Skala Y",
  "ScaleX:": "Skala X:",
  "ScaleY:": "Skala Y:",
  "Schedule": "Schema",
  "Schedule Content": "Schemalägg innehåll",
  "schedule deleted successfully": "Schemat har tagits bort",
  "Schedule functionality will be implemented here.": "Schemaläggning kommer här.",
  "Scheduled": "Schemalagd",
  "Scheduled:": "Schemalagd:",
  "Screen": "Skärm",
  "screen": "skärm",
  "Screen access": "Skärmåtkomst",
  "Screen access updated": "Skärmåtkomsten har uppdaterats",
  "Screen added": "Skärmen har lagts till",
  "Screen Bandwidth": "Skärmarnas bandbredd",
  "Screen Code": "Skärmkod",
  "Screen Content": "Skärminnehåll",
  "Screen Name": "Skärmnamn",
  "Screen Setting": "Skärminställningar",
  "Screen updated.": "Skärmen har uppdaterats.",
  "Screen Usage": "Skärmanvändning",
  "Screens": "Skärmar",
  "Search apps...": "Sök appar...",
  "Search by screen name, MAC or code": "Sök på skärmnamn, MAC eller kod",
  "Search city by Name...": "Sök stad...",
  "Search City:": "Sök stad:",
  "Search content": "Sök innehåll",
  "Search layouts...": "Sök layouter...",
  "Search media...": "Sök media...",
  "Search organization or user...": "Sök organisation eller användare...",
  "Search playlists...": "Sök spellistor...",
  "Search register...": "Sök register...",
  "Search screen": "Sök skärm",
  "Search stop, e.g. Brunnsparken": "Sök hållplats, t.ex. Brunnsparken",
  "Search text tools...": "Sök textverktyg...",
  "Search...": "Sök...",
  "Seconds": "Sekunder",
  "Select a Playlist": "Välj en spellista",
  "Select a text on the canvas to change style.": "Markera en text på layouten för att ändra stil.",
  "Select Action": "Välj åtgärd",
  "Select all": "Markera alla",
  "Select all screens (": "Välj alla skärmar (",
  "Select an image on the layout first.": "Markera en bild på layouten först.",
  "Select an image on the layout, then click a thumbnail here to replace it without changing size or position.": "Markera en bild på layouten och klicka sedan på en miniatyr här för att byta den utan att ändra storlek eller position.",
  "Select Direction:": "Välj riktning:",
  "Select element": "Markera element",
  "Select File": "Välj fil",
  "Select one or more organizations. Leave empty to apply to all organizations.": "Välj en eller flera organisationer. Lämna tomt för att gälla alla.",
  "Select PDF File": "Välj PDF-fil",
  "Select Thumbnail": "Välj miniatyrbild",
  "Select Zone:": "Välj tidszon:",
  "selected": "valda",
  "Send": "Skicka",
  "send": "skicka",
  "Send Back": "Flytta bak",
  "Send instant message on the screen.": "Skicka ett meddelande direkt till skärmen.",
  "Send Message": "Skicka meddelande",
  "Set as global playlist": "Använd som global spellista",
  "Set as layout background": "Använd som layoutbakgrund",
  "Set as organization global playlist (plays on all screens in your organization)": "Använd som global spellista för organisationen (spelas på alla skärmar i organisationen)",
  "Set city name or lat/lon. Data refreshes from OpenWeather every few minutes.": "Ange stad eller lat/lon. Data hämtas från OpenWeather med några minuters mellanrum.",
  "Set Duration": "Ange visningstid",
  "Setting": "Inställningar",
  "Shadow": "Skugga",
  "Shadow blur": "Skuggans oskärpa",
  "Shadow color": "Skuggfärg",
  "shadow Color:": "skuggfärg:",
  "Shadow:": "Skugga:",
  "Shared": "Delad",
  "Sharing": "Delning",
  "Showing": "Visar",
  "Sign up": "Registrera",
  "Size": "Storlek",
  "Slide": "Glid",
  "Soft neumorphic analog": "Mjuk analog",
  "Software": "Programvara",
  "Solid": "Enfärgad",
  "Some files were skipped because they are not supported.": "Vissa filer hoppades över eftersom de inte stöds.",
  "Some old screen selections were removed because they no longer exist.": "Några gamla skärmval togs bort eftersom skärmarna inte finns längre.",
  "Speed value in Millisecond:": "Hastighet i millisekunder:",
  "Sr.#": "Nr",
  "Staff account: cross-org help, no APK or account deletion": "Personalkonto: hjälp i alla organisationer, ingen APK eller kontoborttagning",
  "Staging environment": "Testmiljö",
  "Start Date": "Startdatum",
  "Start Time": "Starttid",
  "Status": "Status",
  "Stop": "Hållplats",
  "Strikethrough": "Genomstruken",
  "Style": "Stil",
  "Subheading": "Underrubrik",
  "Submit": "Skicka",
  "Successfully Loaded!": "Laddat!",
  "Super Admin": "Superadmin",
  "Sync": "Synka",
  "Template": "Layout",
  "Template copied successfully!": "Layouten har kopierats!",
  "Template name is required.": "Layouten måste ha ett namn.",
  "Template stored successfully.": "Layouten har sparats.",
  "Template updated successfully.": "Layouten har uppdaterats.",
  "Templete": "Layouter",
  "Text": "Text",
  "Text color": "Textfärg",
  "Text Color:": "Textfärg:",
  "This account type cannot be changed here.": "Kontotypen kan inte ändras här.",
  "This Apk already available": "Den här APK:n finns redan",
  "This apk not valid.": "APK-filen är ogiltig.",
  "Time Duration": "Visningstid",
  "Time Format:": "Tidsformat:",
  "Time is over, please send again request.": "Tiden har gått ut. Skicka en ny begäran.",
  "Times update on screens every minute. Line colours come from Västtrafik.": "Tiderna uppdateras på skärmarna varje minut. Linjefärgerna kommer från Västtrafik.",
  "Title": "Titel",
  "Title size": "Titelstorlek",
  "To": "Till",
  "to": "till",
  "toggle confirm password visibility": "visa/dölj bekräftat lösenord",
  "Toggle elements panel": "Visa/dölj elementpanelen",
  "toggle new password visibility": "visa/dölj nytt lösenord",
  "toggle password visibility": "visa/dölj lösenord",
  "Toggle properties panel": "Visa/dölj egenskapspanelen",
  "Top Assets": "Mest hämtade filer",
  "total": "totalt",
  "Total Bandwidth": "Total bandbredd",
  "total ·": "totalt ·",
  "Transition": "Övergång",
  "Transition updated": "Övergången har uppdaterats",
  "Try a different search term": "Prova ett annat sökord",
  "Try widening the date range or clearing your search filters.": "Prova en längre period eller rensa sökfiltren.",
  "Type": "Typ",
  "Typeface": "Typsnitt",
  "Underflow": "Inga tidigare sidor",
  "Underline": "Understruken",
  "Units": "Enheter",
  "unknown": "okänd",
  "Untitled": "Namnlös",
  "Untitled layout": "Namnlös layout",
  "Up": "Upp",
  "Update": "Uppdatera",
  "Update All": "Uppdatera alla",
  "Update name, sign-in email, and role (super admin). Other data stays linked to this account (same user ID). Leave new password blank to keep the current password.": "Uppdatera namn, inloggningsmejl och roll (superadmin). Övrig data är kvar på kontot (samma användar-ID). Lämna nytt lösenord tomt för att behålla det nuvarande.",
  "Update the playlist name": "Ändra spellistans namn",
  "Upload": "Ladda upp",
  "Upload Apk": "Ladda upp APK",
  "Upload Date": "Uppladdningsdatum",
  "Upload image content": "Ladda upp bilder",
  "Upload PDF document": "Ladda upp PDF-dokument",
  "Upload Photo": "Ladda upp foto",
  "Upload video content": "Ladda upp video",
  "Uploaded media served from this server": "Uppladdad media som hämtats från servern",
  "URL": "URL",
  "Url": "URL",
  "URL Link": "URL-länk",
  "Use Add organization, Add member, or Add Notiz Support in the toolbar.": "Använd Lägg till organisation, Lägg till medlem eller Lägg till Notiz-support i verktygsfältet.",
  "User": "Användare",
  "user": "användare",
  "User created but invitation email was not sent. Check BREVO_API_KEY on the server.": "Användaren skapades men inbjudan skickades inte. Kontrollera BREVO_API_KEY på servern.",
  "user deleted": "Användaren har tagits bort",
  "User info": "Användarinfo",
  "User Profile": "Användarprofil",
  "User session expired. Please log in again.": "Sessionen har gått ut. Logga in igen.",
  "User updated": "Användaren har uppdaterats",
  "User updated!": "Användaren har uppdaterats!",
  "User updated. Sign in with your new email next time you log in.": "Användaren har uppdaterats. Logga in med din nya e-post nästa gång.",
  "User updated. They should sign in with the new email and password next time.": "Användaren har uppdaterats. Nästa gång loggar de in med ny e-post och nytt lösenord.",
  "User updated. They should use the new password next time they sign in.": "Användaren har uppdaterats. Nästa gång loggar de in med det nya lösenordet.",
  "Username": "Användarnamn",
  "Username is required": "Användarnamn krävs",
  "Username is required.": "Användarnamn krävs.",
  "UTC": "UTC",
  "Valid html required.": "Giltig HTML krävs.",
  "Value is required": "Värde krävs",
  "Version Code": "Versionskod",
  "Version Name": "Versionsnamn",
  "Video": "Video",
  "Video guides": "Videoguider",
  "Video Scale": "Videoskala",
  "View-only access. You cannot create or edit layouts.": "Läsbehörighet. Du kan inte skapa eller ändra layouter.",
  "Viewer": "Läsare",
  "Västtrafik departures": "Västtrafik-avgångar",
  "Västtrafik is not set up on the server yet.": "Västtrafik är inte inställt på servern än.",
  "Weather": "Väder",
  "Weather Widget": "Väderwidget",
  "Web page": "Webbsida",
  "Web player": "Webbspelare",
  "Webpage": "Webbsida",
  "Welcome back,": "Välkommen tillbaka,",
  "white": "vit",
  "Widget": "Widget",
  "widget": "widget",
  "Width": "Bredd",
  "Width:": "Bredd:",
  "width:": "bredd:",
  "Wind Speed": "Vindhastighet",
  "Write Message": "Skriv meddelande",
  "Write Text:": "Skriv text:",
  "Yes": "Ja",
  "Youtube Preview": "Förhandsvisning YouTube",
  "Youtube Widget": "YouTube-widget",
  "Youtube/Playlist Preview": "Förhandsvisning YouTube-spellista",
  "Youtube/Playlist Widget": "YouTube-spellista",
  "Zoom": "Zoom",
  // Statistics page (src/views/statistics)
  "24 h": "24 h",
  "Added": "Tillagd",
  "Alert log": "Larmlogg",
  "All events": "Alla händelser",
  "All screens online": "Alla skärmar är online",
  "Could not load alerts.": "Kunde inte hämta larmen.",
  "Could not load screen statistics.": "Kunde inte hämta statistik för skärmen.",
  "Could not load statistics.": "Kunde inte hämta statistiken.",
  "Current problems": "Problem just nu",
  "Customer": "Kund",
  "Customer view": "Kundvy",
  "Detail": "Detaljer",
  "Device": "Enhet",
  "Event": "Händelse",
  "Internal": "Internt",
  "Internal view": "Intern vy",
  "Internal view: shows all customers, MAC addresses and player problems. Customers never see this.": "Intern vy: visar alla kunder, MAC-adresser och spelarproblem. Kunder ser aldrig detta.",
  "Just now": "Nyss",
  "Last seen": "Senast sedd",
  "Last seen {when}": "Senast sedd {when}",
  "Load error": "Laddningsfel",
  "Longer than 5 minutes": "Längre än 5 minuter",
  "Longest outage": "Längsta avbrott",
  "Longest {time}": "Längsta {time}",
  "Lowest uptime, 30 days": "Lägst upptid, 30 dagar",
  "MAC / device id": "MAC / enhets-id",
  "Never": "Aldrig",
  "Never connected": "Aldrig ansluten",
  "No data": "Ingen data",
  "No data yet": "Ingen data än",
  "No events in this period.": "Inga händelser under perioden.",
  "No problems right now. All screens are online.": "Inga problem just nu. Alla skärmar är online.",
  "No self-heals or load errors in this period.": "Inga självläkningar eller laddningsfel under perioden.",
  "No uptime data yet.": "Ingen upptidsdata än.",
  "Now": "Nu",
  "OS version": "OS-version",
  "Offline alerts are emailed after 10 minutes; self-heals after 3 in 24 h. Never shown to customers.": "Offlinelarm mejlas efter 10 minuter, självläkningar efter 3 på 24 h. Visas aldrig för kunder.",
  "Online and offline": "Online och offline",
  "Online now": "Online nu",
  "Opening hours {from}–{to}": "Öppettid {from}–{to}",
  "Opening hours {window}": "Öppettid {window}",
  "Outages": "Avbrott",
  "Outages 30 days": "Avbrott 30 dagar",
  "Period": "Period",
  "Player problems": "Spelarproblem",
  "RAM": "RAM",
  "Resolution": "Upplösning",
  "Screen or place": "Skärm eller plats",
  "Screen, place or customer": "Skärm, plats eller kund",
  "Self-heal": "Självläkning",
  "Showing the latest 500 events.": "Visar de senaste 500 händelserna.",
  "Statistics": "Statistik",
  "Statistics are not switched on for your account yet.": "Statistik är inte påslaget för ert konto än.",
  "Storage": "Lagring",
  "Time": "Tid",
  "Uptime 30 days": "Upptid 30 dagar",
  "Uptime 7 days": "Upptid 7 dagar",
  "Uptime all day": "Upptid hela dygnet",
  "Uptime in opening hours": "Upptid under öppettid",
  "Uptime and problems for your screens.": "Upptid och problem för era skärmar.",
  "Uptime means the screen had contact with Notiz. Measured since status logging started; time before that is not counted.": "Upptid betyder att skärmen hade kontakt med Notiz. Mäts sedan statusloggningen startade. Tiden innan räknas inte.",
  "View": "Vy",
  "all day": "hela dygnet",
  "offline for {time}": "offline i {time}",
  "{d} d": "{d} d",
  "{d} d {h} h": "{d} d {h} h",
  "{free} free of {total}": "{free} ledigt av {total}",
  "{from}–{to}": "{from}–{to}",
  "{h} h": "{h} h",
  "{h} h {m} min": "{h} h {m} min",
  "{n} days": "{n} dagar",
  "{n} min": "{n} min",
  "{n} offline": "{n} offline",
  "{n} screens · uptime in opening hours {window}": "{n} skärmar · upptid under öppettid {window}",
  "{n} self-heals or load errors in 24 h": "{n} självläkningar eller laddningsfel på 24 h",
  "{pct} around the clock": "{pct} dygnet runt",
  "{time} ago": "för {time} sedan",
  // Notiz Present (screen sharing), the card on a screen's settings page.
  "On: enter the code shown on the screen to connect it": "På: ange koden som visas på skärmen för att koppla den",
  "On, but the screen is not connected": "På, men skärmen är inte ansluten",
  "The screen is connected.": "Skärmen är kopplad.",
  "Wrong code, or the code has expired. Check the screen and try again.": "Fel kod, eller så har koden gått ut. Titta på skärmen och försök igen.",
  "Too many tries. Wait a minute and try again.": "För många försök. Vänta en minut och försök igen.",
  "Could not connect the screen. Try again shortly.": "Kunde inte koppla skärmen. Försök igen om en stund.",
  "Connect the screen again": "Koppla skärmen igen",
  "Enter the code from the screen": "Ange koden från skärmen",
  "Setup link for the screen app": "Installationslänk för skärmappen",
  "Connect the screen": "Koppla skärmen",
  "Within a minute, the screen shows \"Koppla skärmen\" with an 8-digit code in a corner. Enter it here.": "Inom en minut visar skärmen \"Koppla skärmen\" med en åttasiffrig kod i ett hörn. Ange den här.",
  "Code from the screen": "Koden från skärmen",
  "Later": "Senare",
  "Connect": "Koppla",
  "Setup link for the screen app?": "Installationslänk för skärmappen?",
  "Only for screens with the Present screen app that cannot show a code. The screen's current connection stops working at once.": "Bara för skärmar med Present-skärmappen som inte kan visa en kod. Skärmens nuvarande koppling slutar fungera direkt.",
  "Screen sharing (Present)": "Dela skärm (Present)",
  "Off": "Av",
  "On: the code shows on the screen": "På: koden visas på skärmen",
  "On: someone is connecting": "På: någon ansluter",
  "On: someone is sharing their screen": "På: någon delar sin skärm",
  "Screen sharing switched on.": "Dela skärm är påslaget.",
  "Screen sharing switched off.": "Dela skärm är avstängt.",
  "Could not change screen sharing. Try again shortly.": "Kunde inte ändra Dela skärm. Försök igen om en stund.",
  "Could not make a new setup link. Try again shortly.": "Kunde inte skapa en ny installationslänk. Försök igen om en stund.",
  "Copied.": "Kopierad.",
  "Could not copy. Select the link and copy it by hand.": "Kunde inte kopiera. Markera länken och kopiera den själv.",
  "Lets people show their computer screen on this screen with a code. Keep it off for lobby or menu screens.": "Låter besökare visa sin datorskärm på den här skärmen med en kod. Låt det vara av för till exempel entré- och menyskärmar.",
  "Make a new link": "Skapa ny länk",
  "Setup link for the screen": "Installationslänk för skärmen",
  "Open this link once in the screen app on the panel. It works like a password: do not share it or save it anywhere shared. It is only shown now.": "Öppna länken en gång i skärmappen på skärmen. Den fungerar som ett lösenord: dela den inte och spara den inte där andra kommer åt den. Den visas bara nu.",
  "Done": "Klar",
  "Scaling": "Skalning",
  "Fill (crop edges)": "Fyll (beskär kanter)",
  "Fit (show everything)": "Anpassa (visa allt)",
  "Stretch": "Sträck",
  "Scaling updated": "Skalningen har uppdaterats",
  "Could not update scaling": "Kunde inte uppdatera skalningen",
  "Screenshot": "Skärmbild",
  "Take screenshot now": "Ta skärmbild nu",
  "Waiting for the screen…": "Väntar på skärmen…",
  "Latest screenshot": "Senaste skärmbilden",
  "Taken {when}": "Tagen {when}",
  "just now": "nyss",
  "{n} min ago": "för {n} min sedan",
  "{n} h ago": "för {n} h sedan",
  "Asked the screen for a screenshot": "Skärmen har ombetts ta en skärmbild",
  "Could not reach the screen": "Kunde inte nå skärmen",
  "No screenshot yet. Screens with the Notiz Player app send one every 15 minutes.": "Ingen skärmbild än. Skärmar med Notiz Player-appen skickar en var 15:e minut.",
  "Screenshot missing": "Skärmbild saknas",
  "Integrations (beta)": "Integrationer (beta)",
  "Connect the systems you already use and show their information on your screens.": "Anslut systemen ni redan använder och visa informationen på era skärmar.",
  "Catalog": "Katalog",
  "Hotels and hospitality": "Hotell och hospitality",
  "Property and housing": "Fastigheter och BRF",
  "Office and coworking": "Kontor och coworking",
  "Calendar and meeting rooms": "Kalender och mötesrum",
  "Restaurant and POS": "Restaurang och kassasystem",
  "Transport and public transit": "Transport och kollektivtrafik",
  "Weather and news": "Väder och nyheter",
  "Social media": "Sociala medier",
  "Connected": "Ansluten",
  "Not connected": "Inte ansluten",
  "Needs configuration": "Kräver konfiguration",
  "Connection error": "Anslutningsfel",
  "Disconnect": "Koppla från",
  "Add-on – contact Notiz to activate": "Tillägg – kontakta Notiz för att aktivera",
  "Not activated by Notiz yet": "Inte aktiverad av Notiz än",
  "Add-on": "Tillägg",
  "Included": "Ingår",
  "Could not load integrations.": "Kunde inte hämta integrationer.",
  "Something went wrong.": "Något gick fel.",
  "Choose an organization to connect integrations for it.": "Välj en organisation för att ansluta integrationer åt den.",
  "Search integrations": "Sök integrationer",
  "Show connected only": "Visa bara anslutna",
  "No integrations match.": "Inga integrationer matchar.",
  "{name} is connected": "{name} är ansluten",
  "{name} is disconnected": "{name} är frånkopplad",
  "Could not load settings.": "Kunde inte hämta inställningar.",
  "Could not save.": "Kunde inte spara.",
  "Choose which integrations customers see, and what they cost. Premium integrations are unlocked per organization.": "Välj vilka integrationer kunderna ser och vad de kostar. Tillägg låses upp per organisation.",
  "Integration": "Integration",
  "State": "Läge",
  "Offered": "Erbjuds",
  "Beta": "Beta",
  "Price model": "Prismodell",
  "Price text": "Pristext",
  "Working": "Fungerar",
  "Server key missing": "Servernyckel saknas",
  "e.g. 99 kr/month": "t.ex. 99 kr/mån",
  "Category": "Kategori",
  "Settings": "Inställningar",
  "Connect now": "Anslut",
  "Integration widget": "Integrationswidget",
  "News, weather or departures from a connected integration": "Nyheter, väder eller avgångar från en ansluten integration",
  "Could not save the data source.": "Kunde inte spara datakällan.",
  "Connect an integration under Integrations (beta) first.": "Anslut först en integration under Integrationer (beta).",
  "Open Integrations (beta)": "Öppna Integrationer (beta)",
  "Data from": "Data från",
  "Choose integration": "Välj integration",
  "Feed address (https)": "Flödets adress (https)",
  "Saving…": "Sparar…",
  "Use this feed": "Använd flödet",
  "Place": "Ort",
  "e.g. Gothenburg": "t.ex. Göteborg",
  "Use this place": "Använd orten",
  "Screens update every minute. If the source is down, the last fetched data stays on screen.": "Skärmarna uppdateras varje minut. Om källan ligger nere visas senast hämtade data.",
  "Customer activity": "Kundaktivitet",
};

export default dict;
